/**
 * 传感器方案-设备管理
 */
import React, { useState } from 'react';
import { Card, Form, Row, Col, Button, Input } from 'antd';
import { sensorDeviceListRequest } from '@/service/sensorDeviceManage';
import { useTable } from '@/utils/useTable';
import { operateTimeRange } from '@/utils/operateSearchParams';
import { sensorSchemeCommonColumns } from '@/columns/sensorScheme';
import CommonTable from '@/components/commonTable';
import RenderEllipsisColumn from '@/components/renderEllipsisColumn';
import PermissionButton from '@/components/permissionButton';
import SensorCommonSearch from '@/components/sensorCommonSearch';
import SensorDeviceTypeSelect from '@/components/sensorDeviceTypeSelect';
import { formSearchGutter } from '@/constants/common';
import { actuatorName } from '@/constants/sensorScheme';
import OperateModal from './components/operateModal';
import styles from '@/styles/pageContent.module.scss';

const SensorDeviceManage = () => {
  const [form] = Form.useForm();
  const [operateInfo, setOperateInfo] = useState<any>({}); // 操作相关的信息
  const [searchParams, setSearchParams] = useState({}); // 搜索相关的参数
  const { page, limit, loading, data, totalCount, onPageChange, getData } =
    useTable({
      requestFunc: sensorDeviceListRequest,
      searchParams
    });

  // 搜索
  const onSearch = async (values: any) => {
    const newSearchParams = operateTimeRange(values, true);
    setSearchParams(newSearchParams);
  };

  // 表格列显示
  const columns = [
    {
      title: '设备ID',
      dataIndex: 'id',
      width: 70,
      ellipsis: { showTitle: false },
      render: (value: string) => <RenderEllipsisColumn text={value} />
    },
    {
      title: '产品名称',
      dataIndex: 'name',
      width: 110,
      ellipsis: { showTitle: false },
      render: (value: string) => <RenderEllipsisColumn text={value} />
    },
    {
      title: '厂商',
      dataIndex: 'supplierName',
      width: 110,
      ellipsis: { showTitle: false },
      render: (value: string) => <RenderEllipsisColumn text={value} />
    },
    {
      title: '设备类型',
      dataIndex: 'componentTypeName',
      width: 110,
      ellipsis: { showTitle: false },
      render: (value: string, item: any) => (
        <RenderEllipsisColumn
          text={value === actuatorName ? `${value}-${item.typeId}` : value}
        />
      )
    },
    {
      title: '型号',
      dataIndex: 'model',
      width: 110,
      ellipsis: { showTitle: false },
      render: (value: string) => <RenderEllipsisColumn text={value} />
    },
    {
      title: '版本号',
      dataIndex: 'version',
      width: 110,
      ellipsis: { showTitle: false },
      render: (value: string) => <RenderEllipsisColumn text={value} />
    },
    ...sensorSchemeCommonColumns,
    {
      title: '备注',
      dataIndex: 'ps',
      width: 120,
      ellipsis: { showTitle: false },
      render: (value: string) => <RenderEllipsisColumn text={value} />
    },
    {
      title: '操作',
      dataIndex: 'operate',
      width: 120,
      fixed: 'right' as const,
      render: (value: any, item: any) => {
        return (
          <div className={styles.tableOperateColumn}>
            <PermissionButton
              operateType="/car-admin/sensorDevice-manage/edit"
              type="link"
              onClick={() => setOperateInfo({ type: 'edit', data: item })}
            >
              编辑
            </PermissionButton>
            <PermissionButton
              operateType="/car-admin/sensorDevice-manage/viewDetail"
              type="link"
              onClick={() => setOperateInfo({ type: 'detail', data: item })}
            >
              查看
            </PermissionButton>
          </div>
        );
      }
    }
  ];

  return (
    <Card bordered={false} className={styles.fixPageContentBox}>
      <Form onFinish={onSearch} form={form} autoComplete="off">
        <Row gutter={formSearchGutter}>
          <Col span={8}>
            <Form.Item label="产品名称" name="name">
              <Input placeholder="请输入产品名称" allowClear />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="厂商" name="supplierName">
              <Input placeholder="请输入厂商名称" allowClear />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="设备类型" name="componentTypeId">
              <SensorDeviceTypeSelect />
            </Form.Item>
          </Col>
          <SensorCommonSearch span={8} />
          <Col span={6}>
            <Form.Item>
              <div className={styles.searchBox}>
                <Button type="primary" htmlType="submit">
                  搜索
                </Button>
              </div>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <div className={styles.operateBox}>
        <PermissionButton
          operateType="/car-admin/sensorDevice-manage/add"
          type="primary"
          onClick={() => setOperateInfo({ type: 'add' })}
        >
          新增设备
        </PermissionButton>
      </div>
      <CommonTable
        rowKey="id"
        columns={columns}
        dataSource={data}
        pagination={{
          total: totalCount,
          current: page,
          pageSize: limit,
          onChange: onPageChange
        }}
        bordered
        loading={loading}
      />
      {['add', 'edit', 'detail'].includes(operateInfo.type) && (
        <OperateModal
          type={operateInfo.type}
          data={operateInfo.data}
          closeModal={() => setOperateInfo({})}
          reloadData={getData}
        />
      )}
    </Card>
  );
};

export default SensorDeviceManage;
